// Open behaviour shared by the inline links and the related list, mirroring
// LinkEntity.vue: hover = transient peek modal beside the cursor that closes on
// mouseleave (Shift pins it, Modals.vue), click = the usual centred modal.
// Offers have no modal: click opens the offers page in a new tab, hover does
// nothing. The peek waits a short moment so a mouse passing over a dense list
// of names does not flash modals.
import { entityOpenTarget } from '@/utils/recruiterQaEntities'

export const PEEK_DESIGNATOR = 'rqa-entity-peek'
export const PEEK_DELAY_MS = 250

export default {
  beforeDestroy () {
    this.cancelPeek()
  },
  methods: {
    storeModals () {
      const s = this.$store && this.$store.state && this.$store.state.modals
      return (s && Array.isArray(s.modals)) ? s.modals : []
    },
    peekModal () {
      return this.storeModals().find(m => m && m.designator === PEEK_DESIGNATOR)
    },
    peek (entity) {
      this.cancelPeek()
      const target = entityOpenTarget(entity)
      if (target.kind !== 'modal' || !this.$store) return
      this._peekTimer = setTimeout(() => {
        this._peekTimer = null
        // never stack a peek on top of an open modal (click modal, another peek)
        if (this.storeModals().length) return
        this.$store.commit('modals/create', {
          ...target.modal,
          designator: PEEK_DESIGNATOR,
          is_center_modal: false,
          modal_open_action: 'hover',
          modal_width: entity.type === 'applicant' ? undefined : target.modal.modal_width
        })
      }, PEEK_DELAY_MS)
    },
    cancelPeek () {
      if (this._peekTimer) {
        clearTimeout(this._peekTimer)
        this._peekTimer = null
      }
    },
    unpeek () {
      this.cancelPeek()
      const modal = this.peekModal()
      if (modal && this.$store) this.$store.commit('modals/remove', modal) // no-op while Shift-pinned
    },
    open (entity) {
      this.cancelPeek()
      const target = entityOpenTarget(entity)
      this.$emit('open-entity', entity)
      if (target.kind === 'modal') {
        if (!this.$store) return
        const peek = this.peekModal()
        if (peek) this.$store.commit('modals/removeModalById', peek.modal_id)
        this.$store.commit('modals/create', target.modal)
        return
      }
      if (!this.$router || typeof window === 'undefined') return
      const resolved = this.$router.resolve(target.route)
      const href = resolved && resolved.href
      if (href) window.open(href, '_blank', 'noopener')
    }
  }
}
